export default __webpack_public_path__ + "static/media/volvo.d9f3a01a.png";